/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Publish_FacebookInputs */

const cs_social_export_publish_facebook = /** @type {(inputs: Social_Export_Publish_FacebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook stránka`)
};

const en_social_export_publish_facebook = /** @type {(inputs: Social_Export_Publish_FacebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook Page`)
};

/**
* | output |
* | --- |
* | "Facebook Page" |
*
* @param {Social_Export_Publish_FacebookInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_publish_facebook = /** @type {((inputs?: Social_Export_Publish_FacebookInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Publish_FacebookInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_publish_facebook(inputs)
	return cs_social_export_publish_facebook(inputs)
});